import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      icon: 'Shield',
      label: 'SSL Secured',
      color: 'text-success'
    },
    {
      icon: 'Lock',
      label: 'Privacy-First',
      color: 'text-primary'
    },
    {
      icon: 'CheckCircle2',
      label: 'Secure by Design',
      color: 'text-accent'
    }
  ];

  return (
    <div className="mt-6 pt-6 border-t border-border">
      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
        {trustBadges?.map((badge, index) => (
          <div
            key={index}
            className="flex items-center gap-2"
          >
            <Icon
              name={badge?.icon}
              size={16}
              className={badge?.color}
            />
            <span className="text-xs text-muted-foreground font-medium">
              {badge?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;